/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : DisplayTotalPriceCard.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H422335
*
* @Date         : Sept 24, 2020
*
* @Version      : Version 1.0
*
*
* By             : H422336
* On             : Oct 08,2020
* Description    : ASDS-3515 APU enhancements as part of phase-2 bugfix
*
******************************************************************************/
import * as React from 'react';
import { Grid, Card } from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import './ConfigureAPU.css';

interface ITotalPriceCardProps {
    totalPrice: number;
}

function TotalPriceCard(props: ITotalPriceCardProps) {
    return (
        <Card >
            <Card.Content>
                <Grid className="total-price-card">
                    <Grid.Row>
                        <Grid.Column width={10} className="flex-direction-vertical">
                            <div className="tax-exemption-text">If you are tax exempt, please email us the tax certificate to</div>
                            <div className="tax-exemption-email"><a href="mailto:dsa@honeywellaerospace.com">dsa@honeywellaerospace.com</a></div>

                        </Grid.Column>
                        <Grid.Column width={2} className="flex-direction-vertical">
                            <div className="total-price-text">Total Price</div>
                            <div className="total-price-amount">{`$${props.totalPrice.toFixed(2)}`}</div>
                            <div className="taxes-applicable-disclaimer">+Taxes as applicable</div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Card.Content>
        </Card>
    );
}

export default TotalPriceCard;